'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var _babelHelpers = require('../_babelHelpers-48e7a7f7.js');
var settings = require('../settings-9ee2f03f.js');
var camelCase = _interopDefault(require('lodash/camelCase'));
require('../style-222d2b0f.js');
var polished_es = require('../polished.es-a11ee845.js');
var span = require('../typography/span.js');

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  ", "\n  cursor: pointer;\n  ", ";\n"], ["\n  ", "\n  cursor: pointer;\n  ", ";\n"]),
    _templateObject2 = _babelHelpers.taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-start;\n  align-items: ", ";\n"], ["\n  display: flex;\n  justify-content: flex-start;\n  align-items: ", ";\n"]),
    _templateObject3 = _babelHelpers.taggedTemplateLiteral(["\n  width: auto;\n  height: 24px;\n  ", "\n"], ["\n  width: auto;\n  height: 24px;\n  ", "\n"]),
    _templateObject4 = _babelHelpers.taggedTemplateLiteral(["\n  font-size: ", ";\n  ", ";\n  color: inherit;\n  margin: ", ";\n"], ["\n  font-size: ", ";\n  ", ";\n  color: inherit;\n  margin: ", ";\n"]),
    _templateObject5 = _babelHelpers.taggedTemplateLiteral(["\n  ", ";\n  position: relative;\n  width: 24px;\n  height: 24px;\n  margin: ", ";\n"], ["\n  ", ";\n  position: relative;\n  width: 24px;\n  height: 24px;\n  margin: ", ";\n"]),
    _templateObject6 = _babelHelpers.taggedTemplateLiteral(["\n  width: 30px;\n  height: 30px;\n  background: transparent;\n  position: absolute;\n  transition: all, 0.5s;\n  border-radius: 50px;\n"], ["\n  width: 30px;\n  height: 30px;\n  background: transparent;\n  position: absolute;\n  transition: all, 0.5s;\n  border-radius: 50px;\n"]);

/* eslint-disable no-nested-ternary */
var StyledCheckBox = styled__default.div(_templateObject, function (props) {
  return props.simple ? "\n  margin: " + (props.margin ? props.margin : "5px 0") + ";\n  padding: 0;\n  background-color: " + (props.bgSimpleTransparent ? "transparent" : settings.COLOR.white) + ";\n  " + (!props.disabled && "&:hover {\n      .checkboxHoverBg {\n        background: " + (props.error ? polished_es.rgba(settings.COLOR.softRed, 0.15) : props.isSelected ? polished_es.rgba(settings.COLOR.deepBlue, 0.15) : polished_es.rgba(settings.COLOR.lightGray, 0.15)) + ";\n      }\n    }") + "\n  @media (max-width: 767px) {\n    margin: " + (props.mMargin ? props.mMargin : "0px") + ";\n  }\n  " : "\n  margin: 20px 0;\n  padding: 14px;\n  height: auto; \n  border-radius: 5px;\n  border: 2px solid " + (props.error ? "" + settings.COLOR.softRed : props.isSelected ? " " + settings.COLOR.brightBlue : "transparent") + ";\n  box-shadow: " + settings.CHECKBOX_NORMAL_SHADOW + ";\n  box-sizing: border-box;\n  background-color: \n  " + (props.error ? polished_es.rgba(settings.COLOR.softRed, 0.1) : props.isSelected ? settings.COLOR.lightDeepBlue : settings.COLOR.white) + ";\n  transition: box-shadow ease-in-out " + settings.ANIMATE.FAST + ";\n  &:hover,\n  &:focus {\n    box-shadow: " + settings.CHECKBOX_HOVER_SHADOW + ";\n  }\n  @media (max-width: 767px) {\n    height: auto;\n  }\n";
}, function (props) {
  return props.disabled && "\n    opacity: 0.2;\n    pointer-events: none;\n    cursor: not-allowed;\n  ";
});
/* eslint-enable no-nested-ternary */

var FlexContent = styled__default.div(_templateObject2, function (props) {
  return props.simple ? "flex-start" : "center";
});

var ImgIcon = styled__default.img(_templateObject3, function (props) {
  return props.simple && "\n  @media (max-width: 767px) {\n    height: " + (props.mHeight ? props.mHeight : "35px") + ";\n  }\n";
});

var Text = styled__default.p(_templateObject4, function (props) {
  return props.fontSize ? props.fontSize : "14px";
}, function (props) {
  return props.bold && "font-weight: 600";
}, function (props) {
  return props.simple ? "auto 0" : "0";
});

var CheckboxIcon = styled__default.div(_templateObject5, settings.FLEX_CENTER, function (props) {
  return props.simple ? "0 10px 0 0" : "0 15px 0 0";
});
var HoveredBg = styled__default.div(_templateObject6);

var uncheckSquare = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAYAAADFeBvrAAAAAXNSR0IArs4c6QAAAfdJREFUaAXtWTFqw0AQtKQgLEiTLoV/kCovCKhIpUqgNkVS5Al5Q56QIikCqQyqXKUw5AWp8oMU6dIYbAyWsyN8IA58ew6WvBarRnc+787MzukE2mC9XkeDHl1hj7TUUlSQdEfVIXWo4wr0bsud7FLAsizvqqq6pXfXBcWd7hL7j//OgiD4CsPwJc/zZ9/4wOfFOplMzufz+SslTX0T7/l/0yRJbrIs++HyejlkxFDFvqliD3Ecf/gk58Bd6yjicrm8oh3xSEVPNxyuXTFYYx3CNlutVk8QMxwOL0nIL5d0n+sk7GyxWHySqFEURffc9mMPBTwzIAhnuhYDXGACG2PDBeNtFytocwAMsM22JWn7d4NtuLjwWEEUXJ9mbT8zLpINbPZk9RHkwhK3poLEWWIRUoesgoibqkPiLLEIqUNWQcRN1SFxlliE1CGrIOKm6pA4SyxC6pBVEHFTdUicJRYhdcgqiLipOiTOEouQj0MzxOBbsxXb2bSBXXNxAbOC0NJAAnw4dyVqc81gGy4uLFYQ+jNIgC4APpy7krWxBkxgI7fh4sJhuw8IHo/H73RLD9hOGRH+tCgKtp3i1R9Cswn9GfRpqLXyRmOIhNaurrrh5QPm5ZBJ1JuWpBF0DHf2UDgGEU2OKqhZDYljdUiiK01O6lCzGhLHf8q9uR0axKnfAAAAAElFTkSuQmCC";

var checkSquare = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAYAAADFeBvrAAAAAXNSR0IArs4c6QAAAy9JREFUaAXtmU9rFDEUwF9mq3ar+A8RRcHTevHkF6i1iAfp4kEQVKygxS74AbxZpCfPIuzqumDBCoKIVhBEytYv4EkEvSqKh/oHu1uxm5i3GgnDvJlJJjMdlskl2TfJe++X95LJTpgQogQDVLwBYumjFEB5j2gRoSJCGc/AwKXckMkEnrz961JP8ItMwCEBYovJWNO+z2ojpG9nH8CO+TPwNUgnOUjvfGEO9ix3unMSYhzlQn+YcfvUfdj7ZYUvjjZh6dWUV/ObjwX0H4axD0OMXd02PLx0bxI++5Wl/VvByImtCA6V0SYHPxSLOvr004z3GiBh9m0tH24Qoc4SRrfleaypQ0VuCrhmUAFGJm8w6BfnYkpGqo5tLJFAuAFgR0wzrLMueppRtnWoyJSbqHfWUFHYrkMZSiqPA6PbkFl0JTJC+oAs26YwDGDhaMVr5RLIBubYwdLpmTH4nTugJDCYQbkCSgrjDKgNwG4+h1gvaTQaVFzAoN5ETqCCtoS5doe35At6+3L7bx6j3KS4gkGbiVKu/Q+GC3Fenu+qL9/1Hl5vw4b1gkkEpMMoAFMol5FRPlhFKAhGKYwLlQYM+mAMFAYTFyotGCugmSafxTWjnKdqKlJpwlgB7Sp7txiw9xSILvdDpQ1jBfToHHzavdkbN4WamIcD+E8T/5zp0FQbz2bqOEP1CZIbryFUYgP1bYW/TQJTbXSeVhvdx0EQuswKyAYKhNioG6baVGSEgBPy5V2lxim5NRAqMI2UMkrVFAzVP0ieCAgVuoJyAYP+JAZyAeUKxhlQEiiXME6BbKBcwzgHMoFKAyYVoDhQacGkBhQGlSZMLCB5xPmJHfGDPdYmxb+l28Io28qXMB8it23B4A0q+L66eiRMEfVMQclv0LM2ZzPdtvKFsoXyyC+n6/2xflreBX380X0tj077S15p+snlTXcTAeHgar37on83lOF1CqYZZsWaEDcQRqbb4kKtfDwMBp9FRgg7+S+8UJZlQZidI+XJOHdSsYCU81leSeIGgGumxLxWVJop/7A2AtIH5rUducvl1XHKrwKImpm8yIsI5SUSlB9FhKiZyYv8DzGjEFYGDNP8AAAAAElFTkSuQmCC";

var errorSquare = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAYAAADFeBvrAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFqSURBVHgB7ZlNboMwEEbHhCarSnCTHIHeIIv8LMkN2p4AOEG5Qck2ySJH4Ai5CUhdRQLcMaTbjLuxJ9K8TWxpbPPCiIU/AEEQBEHwh7ItbNbrZKZUpgGWOI3AEfiAdQ9wiE+nyrKe5me7zQatc/BIoFT+ejwWVB0p1Gw2+wDg24xRqoCuK+PLpQUHNKtVBGG4R5mv+/lv8flcP1oTEnvCDCDV02afuFkJDrn/cSW2e4RSmWl5nNeP1gTUpiiTjIOuq8AX2BUwPcuSKiWF/nDVZsTZ5MfIWuhZECHuiBB3RIg7IsQdEeKOCHFHhLgjQtwRIe6IEHdEiDsixB0bofHWcrw498R/ziaFMJ64joMw/ABPvCwWqfnVWtdULZk+9Bih4M1/Ym7/m92uhdutchmnhPP5ez8MuZlrpQ7UGqvAC+OMPJiiDG+YbArjnJyqs48kMfhSWqcK3xa4o8U2u2KMUlBBlyAIgiBw4Be99m5w7fn1nAAAAABJRU5ErkJggg==";

var Checkbox = function (_React$Component) {
  _babelHelpers.inherits(Checkbox, _React$Component);

  function Checkbox() {
    _babelHelpers.classCallCheck(this, Checkbox);
    return _babelHelpers.possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).apply(this, arguments));
  }

  _babelHelpers.createClass(Checkbox, [{
    key: "checkBoxIconSelector",
    value: function checkBoxIconSelector(error, isSelected) {
      if (error) {
        return errorSquare;
      }
      if (isSelected) {
        return checkSquare;
      }
      return uncheckSquare;
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          id = _props.id,
          onClick = _props.onClick,
          disabled = _props.disabled,
          isSelected = _props.isSelected,
          label = _props.label,
          secondaryLabel = _props.secondaryLabel,
          secondLabelFontStyle = _props.secondLabelFontStyle,
          secondaryLabelColor = _props.secondaryLabelColor,
          fontSize = _props.fontSize,
          labelBold = _props.labelBold,
          simple = _props.simple,
          bgSimpleTransparent = _props.bgSimpleTransparent,
          labelDescription = _props.labelDescription,
          descriptionFontSize = _props.descriptionFontSize,
          display = _props.display,
          margin = _props.margin,
          mMargin = _props.mMargin,
          error = _props.error,
          dataTestId = _props.dataTestId,
          children = _props.children;

      return React__default.createElement(
        StyledCheckBox,
        {
          id: camelCase(id),
          "data-testId": dataTestId,
          onClick: onClick,
          disabled: disabled,
          isSelected: isSelected,
          simple: simple,
          margin: margin,
          mMargin: mMargin,
          error: error,
          bgSimpleTransparent: bgSimpleTransparent },
        React__default.createElement(
          FlexContent,
          { simple: simple },
          React__default.createElement(
            CheckboxIcon,
            { simple: simple },
            React__default.createElement(HoveredBg, { className: "checkboxHoverBg" }),
            React__default.createElement(ImgIcon, {
              src: this.checkBoxIconSelector(error, isSelected),
              simple: simple,
              mHeight: "24px"
            })
          ),
          React__default.createElement(
            Text,
            { bold: labelBold, fontSize: fontSize, simple: simple },
            children,
            label,
            secondaryLabel && React__default.createElement(
              span,
              {
                ml: 5,
                weight: "normal",
                fontStyle: secondLabelFontStyle,
                color: secondaryLabelColor,
                size: fontSize },
              secondaryLabel
            )
          )
        ),
        labelDescription && React__default.createElement(
          span,
          {
            weight: "normal",
            size: descriptionFontSize || "14px",
            color: secondaryLabelColor,
            display: display,
            margin: simple ? "0 0 0 34px" : "0 0 0 39px",
            mMargin: simple ? "0 0 0 44px" : "0 0 0 39px" },
          labelDescription
        )
      );
    }
  }]);
  return Checkbox;
}(React__default.Component);

Checkbox.propTypes = {
  /** component id */
  id: PropTypes.string.isRequired,
  /** text to display for each checkbox */
  label: PropTypes.string.isRequired,
  /** bold style for label */
  labelBold: PropTypes.bool,
  /** text to display after label */
  secondaryLabel: PropTypes.string,
  /** font style for secondary label */
  secondLabelFontStyle: PropTypes.string,
  /** font color for secondary label */
  secondaryLabelColor: PropTypes.string,
  /** font size for both label */
  fontSize: PropTypes.string,
  /** indicator to display selected state checkbox */
  isSelected: PropTypes.bool,
  /** onClick function of checkbox */
  onClick: PropTypes.func.isRequired,
  /** indicator to display disabled state checkbox */
  disabled: PropTypes.bool,
  /** Display for change display checkbok rebel */
  display: PropTypes.string,
  /** indicator to display error state checkbox */
  error: PropTypes.bool
};
Checkbox.defaultProps = {
  disabled: false,
  isSelected: false,
  secondLabelFontStyle: "italic",
  secondaryLabelColor: "#aaaaaa",
  fontSize: "14px",
  display: "inherit",
  error: false
};
Checkbox.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "checkBoxIconSelector",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "error",
      "type": null
    }, {
      "name": "isSelected",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "Checkbox",
  "props": {
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicator to display disabled state checkbox"
    },
    "isSelected": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicator to display selected state checkbox"
    },
    "secondLabelFontStyle": {
      "defaultValue": {
        "value": "\"italic\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "font style for secondary label"
    },
    "secondaryLabelColor": {
      "defaultValue": {
        "value": "\"#aaaaaa\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "font color for secondary label"
    },
    "fontSize": {
      "defaultValue": {
        "value": "\"14px\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "font size for both label"
    },
    "display": {
      "defaultValue": {
        "value": "\"inherit\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Display for change display checkbok rebel"
    },
    "error": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicator to display error state checkbox"
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "component id"
    },
    "label": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "text to display for each checkbox"
    },
    "labelBold": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "bold style for label"
    },
    "secondaryLabel": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "text to display after label"
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": "onClick function of checkbox"
    }
  }
};

module.exports = Checkbox;
//# sourceMappingURL=checkbox.js.map
